import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/close.svg'
import _imports_1 from '@/assets/navbar-icons/search.svg'


const _hoisted_1 = { class: "w-full relative" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "absolute h-10 w-10 top-4 right-1 text-red-400 cursor-pointer z-50"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GMapAutocomplete, {
      id: "location",
      placeholder: "Search for a location",
      onPlace_changed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPlace($event))),
      class: "relative",
      value: _ctx.address
    }, null, 8, ["value"]),
    (!_ctx.validAddress)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Please enter a valid address"))
      : _createCommentVNode("", true),
    (_ctx.address)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "absolute h-10 w-10 top-4 right-1 text-red-400 cursor-pointer z-50",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args)))
        }, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
  ]))
}